const ProfessionalReducer = (state = { free: [],completed:[],pending:[] }, action) => {
    switch (action.type) {
        case "FREE":
            return {
                ...state,
                free: action.payload,
            };
        case "COMPLETED":
            return {
                ...state,
                completed: action.payload,
            };
        case "PENDING":
            console.log(action)
            return {
                ...state,
                pending: action.payload,
            };
        default:
            return state;
    }
};

export default ProfessionalReducer;
